import { applyMiddleware, compose, createStore } from '@reduxjs/toolkit';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';
import createRootReducer from './reducers';

const middlewareEnhancer = applyMiddleware(
  thunkMiddleware,
  // other middlewares
);

const composedEnhancers = (process.env.NODE_ENV !== 'production' ?
  composeWithDevTools(middlewareEnhancer) : compose(middlewareEnhancer)
);

export default function configureStore(preloadedState) {
  const store = createStore(
    createRootReducer(),
    preloadedState,
    composedEnhancers,
  )
  return store;
};